<template>
  <section>
    <div>
      <img src="../assets/profile.jpg" alt />
    </div>
    <div class="name">윤성문</div>
    <div class="job">INPOCK FrontEnd Developer</div>
    <div class="job">(주)인포크 공동창업자</div>
  </section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
$size: 64px;
section {
  img {
    width: $size;
    height: $size;
    border-radius: 50%;
    display: block;
    margin-bottom: 8px;
  }
  .name {
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -1px;
  }
  .job {
    color: #343434;
    font-size: 16px;
  }
}
</style>
